import React, { FC, useState } from 'react'
import { TrophyMemoryDto } from '~/modules/Trophies/Infrastructure/TrophyDetailComponentDto'
import styles from './TrophyMemoryCard.module.scss'
import { useTranslation } from 'next-i18next'
import { TrophyMemoryLightbox } from '~/modules/TrophyMemories/Infrastructure/Components/TrophyMemoryLightbox'

interface Props {
  memoryCardDto: TrophyMemoryDto
}

export const TrophyMemoryCard: FC<Props> = ({ memoryCardDto }) => {
  const { t } = useTranslation('trophy_memories')
  const [active, setActive] = useState<boolean>(() => false)

  return (
    <section
      className={ styles.trophyMemoryCard__container }
      onClick={ () => {
        setActive(!active)
      } }
    >
      <div className={ styles.trophyMemoryCard__imageWrapper }>
        <img
          className={ styles.trophyMemoryCard__media }
          src={ memoryCardDto.thumbnailUrl }
          alt={ t('memory_thumbnail_alt') }
        />
      </div>
      <div className={ styles.trophyMemoryCard__data }>
        <p className={ styles.trophyMemoryCard__mediaType }>
          { memoryCardDto.type }
        </p>
        <p className={ styles.trophyMemoryCard__date }>
          { t('created_at', { date: memoryCardDto.createdAt }) }
        </p>
      </div>
      <TrophyMemoryLightbox memory={ memoryCardDto } active={ active } setActive={ setActive } />
    </section>
  )
}
